<template>
  <section class="contact-section bg-light mt-50 pb-50" id="contact-section">
    <div class="container">
      <div class="row justify-content-center mb-5 pb-3">
        <div class="col-md-10 heading-section text-center">
          <h2 class="mb-4">Contact Us</h2>
          <p>Take your first step towards financial freedom! Call us or leave a message!</p>
        </div>
      </div>
      <div class="row d-flex contact-info mb-5">
        <div class="col-md-6 col-lg-4 d-flex justify-content-center">
          <div class="align-self-stretch box p-4 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <h3 class="mb-4">Address</h3>
            <p>120 Sylvan Ave, Englewood Cliffs, NJ 07632</p>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex justify-content-center">
          <div class="align-self-stretch box p-4 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <i class="fas fa-phone"></i>
            </div>
            <h3 class="mb-4">Contact Number</h3>
            <p>
              <a href="tel: +1(877) 817‑0404">+1(877) 817‑0404</a>
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 d-flex justify-content-center">
          <div class="align-self-stretch box p-4 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <i class="fas fa-envelope"></i>
            </div>
            <h3 class="mb-4">Email Address</h3>
            <p>
              <a href="mailto: info@businessdebtadjusters.com">info@businessdebtadjusters.com</a>
            </p>
          </div>
        </div>
      </div>
      <div class="row form_map_block">
        <div class="col-md-6 order-md-last d-flex form_parent">
          <Form />
        </div>

        <div class="col-md-6 d-flex">
          <div id="map" class="bg-white">
            <GoogleMap />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GoogleMap from "@/components/googleMap";
import Form from "@/components/form";
export default {
  components: {
    GoogleMap,
    Form
  }
};
</script>

<style lang="scss" scoped>
.form_map_block{
  padding: 0 20px;
}
#map {
  width: 100%;
}

.icon {
  font-size: 30px;
  margin-bottom: 10px;
  svg {
    width: 70px;
    height: 70px;
    background: #0062cc;
    color: #fff;
    padding: 20px;
    border-radius: 50%;
  }
}
.form_parent {
  padding: 20px 0;
  box-shadow: 0px 0px 9px -1px rgba(0,0,0,1);
}
@media (max-width: 767px) {
  .form_parent {
  margin: 15px;
}
}
</style>